
import React from 'react'
import {Modal} from 'pepsico-ds'
import { useSessionTimeout } from './SessionTimeoutContext.tsx'

export default function SessionTimeoutModal() {
  const { showTimeoutDialog, closeModal, handleOkAndLogout, handleReLogin } = useSessionTimeout()

  return (
    <>        
    <Modal
      id="actionModal"
      className="Session-expire-modal"
      onCloseModal={closeModal}
      closeOnOutsideClick={false}
      hideCloseButton={true}
      showModal={showTimeoutDialog}
      style={{}}
      showAuxiliaryButton={false}
      showSecondaryButton={true}
      secondaryButtonProps={{
        onClick: () => {
          handleOkAndLogout()
        },
        size: 'medium',
        text: `Logout`,
        variant: 'primary'
      }}
      primaryButtonProps={{
        onClick: () => {
          handleReLogin()
        },
        size: 'medium',
        text: 'Continue',
        variant: 'secondary'
      }}
      auxiliaryButtonProps={null}
      tertiaryButtonProps={null}
      title="Session Timeout"
      titleIcon=""
      text={"Your session has expired. Please re-authenticate to continue."}
      
     />
        {/* <div>
          <h5 style={{fontSize:'18px'}}>Session Timeout</h5>
          <p style={{fontSize:'14px'}}>Your session has expired. Please re-authenticate to continue.</p>
        </div>
    </Modal> */}
    </>
  )
}